import React, { useState, useEffect } from "react";
import CategoriesFull from "../Component/CategoriesFull";
import { Grid, Typography, Container, Box, Link } from "@mui/material";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import CategoriesImg from "../Asset/images/banner-categories.png";
import SubFooter from "../Component/SubFooter";
import axios from "axios";
import config from "../config";

function Categories() {
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    axios
      .get(`${config.url}/product_categories?offset=0&limit=9999`, config.token)
      .then((res) => {
        setCategoryList(res.data.data);
      });
  }, []);

  return (
    <React.Fragment>
      <Header />
      <Box
        sx={{
          textAlign: "center",
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          color: "#fff",
          display: {
            xs: "none",
            sm: "none",
            lg: "block",
          },
        }}
      >
        <Typography variant="h5" sx={{ pb: "20px" }}>
          CATEGORIES
        </Typography>

        {categoryList?.map((data, idx) => (
          <React.Fragment key={idx}>
            <Link
              key={idx}
              href={`/category/${data.id}`}
              underline="none"
              sx={{ m: "10px", color: "#fff" }}
            >
              {data.name}
            </Link>
            {idx === 4 && (
              <>
                <br />
                <br />
              </>
            )}
          </React.Fragment>
        ))}
      </Box>
      <Box
        sx={{
          borderRadius: 10,
          m: "20px",
          overflow: "hidden",
        }}
      >
        <img
          src={CategoriesImg}
          alt="header"
          style={{ width: "100%", objectFit: "cover" }}
        />
      </Box>
      <Container maxWidth="xl" sx={{ mt: "30x", mb: "30px", color: "#5a5a56" }}>
        <Grid container sx={{ pt: "20px", textAlign: "center" }}>
          <Grid item xs={1} />
          <Grid item xs={10} container>
            {categoryList.map(
              (data, idx) =>
                data.products.length > 0 && (
                  <Grid container key={idx} sx={{ mb: "20px" }}>
                    <Grid item sm={12}>
                      <Typography
                        variant="h6"
                        sx={{ textAlign: "left", fontWeight: "bold" }}
                      >
                        {data.name}
                      </Typography>
                    </Grid>
                    {data?.products?.map((isValue, idx) => (
                      <Grid item sm={6} key={idx}>
                        <CategoriesFull data={isValue} type={"category"} />
                      </Grid>
                    ))}
                  </Grid>
                )
            )}
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </Container>
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
}

export default Categories;
